const isNotNullOrUndefined = (value) => {
    return value !== null && value !== undefined;
};

export {
    isNotNullOrUndefined
}